import React from "react";
import { Box, Hidden } from "@mui/material";
import { DesktopFooter } from "./footer/DesktopFooter";
import { MobileFooter } from "./footer/MobileFooter";

export const Footer = ({ translate }) => {
  return (
    <Box
      style={{
        // position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "black",
        color: "white",
        minHeight: "auto",
      }}
    >
      <Hidden mdDown>
        <DesktopFooter translate={translate} />
      </Hidden>
      <Hidden mdUp>
        <MobileFooter translate={translate} />
      </Hidden>
    </Box>
  );
};
